const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
export const Base64 = {
    btoa: (input = "") => {
        try {
            let str = input;
            let output = "";

            for (
                let block = 0, charCode, i = 0, map = chars;
                str.charAt(i | 0) || ((map = "="), i % 1);
                output += map.charAt(63 & (block >> (8 - (i % 1) * 8)))
            ) {
                charCode = str.charCodeAt((i += 3 / 4));

                if (charCode > 0xff) {
                    throw new Error(
                        "'btoa' failed: The string to be encoded contains characters outside of the Latin1 range."
                    );
                }

                block = (block << 8) | charCode;
            }

            return output;
        } catch (e) {
            return null;
        }
    },

    atob: (input = "") => {
        try {
            let str = input.replace(/=+$/, "");
            let output = "";

            if (str.length % 4 === 1) {
                throw new Error(
                    "'atob' failed: The string to be decoded is not correctly encoded."
                );
            }
            for (
                let bc = 0, bs = 0, buffer, i = 0;
                (buffer = str.charAt(i++));
                ~buffer && ((bs = bc % 4 ? bs * 64 + buffer : buffer), bc++ % 4)
                    ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
                    : 0
            ) {
                buffer = chars.indexOf(buffer);
            }

            return output;
        } catch (e) {
            return null;
        }
    }
};

export const base64Logic = (payload, action) => {
    let base64 = {},
        newPayload = payload;
    if (action === "decode") {
        try {
            base64 = eval(`(${Base64.atob(newPayload)})`);
        } catch (e) {
            base64 = {};
        }
    }
    if (action === "encode") {
        newPayload = JSON.stringify(newPayload);
        try {
            base64 = newPayload ? new Buffer(newPayload).toString("base64") : {};
        } catch (e) {
            base64 = Base64.btoa(newPayload);
        }
    }
    return base64;
};